/**
 * Single source of truth for all navigation items across desktop and mobile
 */

import { getCalculatorMenuItems } from "./calculators";

import { getGuidelineList } from "../utils/getConstants";

// Generate guidelines menu from centralised data
export const GUIDELINES_MENU_ITEMS = getGuidelineList().map((guideline) => ({
  id: guideline.linkText.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and"),
  title: guideline.linkText,
  path: `/guidelines/${guideline.onClickProps.replaceAll(" ", "_")}`,
  iconClassSuffix: guideline.iconClassSuffix,
  onClickProps: guideline.onClickProps,
}));

export const RESOURCE_MENU_ITEMS = [
  {
    id: "antibiotic-summary",
    title: "Antibiotic prescribing in primary care - summary table",
    path: "/resources/antibiotic-summary",
    isExternal: true,
    externalUrl: `https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/PDFs/Antibiotic-Summary-table.pdf`,
  },
  {
    id: "surgical-prophylaxis",
    title: "Surgical prophylaxis - summary tables",
    path: "/resources/surgical-prophylaxis",
    isExternal: true,
    externalUrl: `https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/PDFs/ABG17-SAP-summary-tables-collated.pdf`,
  },
  {
    id: "patient-info",
    title: "Patient information and useful PDFs",
    path: "/resources/patient-info",
  },
  {
    id: "pregnancy-breastfeeding",
    title: "Pregnancy and breastfeeding",
    path: "/guidelines/Pregnancy_and_Breastfeeding",
  },
  {
    id: "tables-figures",
    title: "Tables and figures",
    path: "/resources/tables-and-figures",
  },
];

export const MAIN_NAVIGATION_ITEMS = [
  {
    id: "guidelines",
    icon: "tg-icons-Guidelines",
    title: "Guidelines",
    path: "/guidelines/",
    iconStyle: "largeIcon",
    type: "submenu",
    subMenuItems: GUIDELINES_MENU_ITEMS,
  },
  {
    id: "calculators",
    icon: "tg-icons-Calculator",
    title: "Calculators",
    path: "/calculator/",
    iconStyle: "icon",
    type: "submenu",
    subMenuItems: () => getCalculatorMenuItems(),
  },
  {
    id: "resources",
    icon: "tg-icons-Resources",
    title: "Resources",
    path: "/resources/",
    iconStyle: "smallIcon",
    type: "submenu", // Has submenu
    subMenuItems: RESOURCE_MENU_ITEMS,
  },
  {
    id: "favourites",
    icon: "tg-icons-Favourite",
    title: "Favourites",
    path: "/favourites",
    iconStyle: "largeIcon",
    type: "link",
  },
];

export const getNavigationItems = () => {
  return MAIN_NAVIGATION_ITEMS.map((item) => ({
    ...item,
    subMenuItems: typeof item.subMenuItems === "function" ? item.subMenuItems() : item.subMenuItems,
  }));
};

export const getNavigationItem = (id) => {
  const items = getNavigationItems();
  return items.find((item) => item.id === id);
};

export const hasSubmenu = (id) => {
  const item = getNavigationItem(id);
  return item && item.type === "submenu" && item.subMenuItems && item.subMenuItems.length > 0;
};
